import OxygenTextarea from '@8x8/oxygen-textarea'
import styled from 'styled-components'

const Input = styled(OxygenTextarea).attrs(({ theme }) => ({
  theme: {
    textareaBackgroundColor: theme.backgroundInput,
    textareaBorderColor: theme.borderColorInput,
    textareaBorderColorFocus: theme.colorHighlight,
    textareaColor: theme.colorInput,
    textareaPlaceholderColor: theme.colorSecondary
  }
}))``

export default Input
